import { Component, Vue } from 'vue-property-decorator';
import { CustomerLocationOption } from '@/types/types';
import { CustomerLocationFields } from '@/types/graphql/schemaTypes';

// gql
import fetchCustomerLocationsQuery from '@/graphql/queries/FetchCustomerLocations.gql';

@Component({
  apollo: {
    customerLocationOptions: {
      query: fetchCustomerLocationsQuery,
      debounce: 300,
      prefetch: true,
      variables() {
        return {
          filters: {
            customerOrganizationId: this.customerOrganization.id || '',
            hidden: false,
            name: this.searchCustomerLocation
          }
        };
      },
      skip() {
        return !this.customerOrganization.id;
      },
      update(data): CustomerLocationOption<CustomerLocationFields>[] {
        const options = data.customerLocations.map(this.formatCustomerLocationOptions);

        if (this.addCreation) {
          options.unshift({
            value: 'new',
            label: this.searchCustomerLocation,
            isCreation: true
          });
        }
        return options;
      }
    }
  }
})

export default class LocationOptionsMixin extends Vue {
  public addCreation = true; // add creation in select option
  public customerLocationOptions: CustomerLocationOption<CustomerLocationFields>[] = [];
  public searchCustomerLocation = '';
  // NOTE: Set customerOrganization in your component when you use LocationOptionsMixin
  // public customerOrganization: CustomerOrganizationFields | null = null;

  public combineAddress(location) {
    return `${location.region ? location.region : ''}${location.city}${location.fullAddress}`;
  }

  public formatCustomerLocationOptions(location: CustomerLocationFields) {
    return {
      label: location.name,
      value: location,
      combinedAddress: this.combineAddress(location)
    };
  }
}
